import { useState, useEffect } from 'react';

/**
 * Returns the current Date, refreshed on a fixed interval.
 * Use this to drive live countdowns without polling any API.
 * @param intervalMs How often to refresh (default: 60 000ms = 1 minute)
 */
export function useNow(intervalMs = 60_000): Date {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
}
